import { z } from "zod";

const baseRateSchema = z.object({
  rate: z.number().min(1, { message: "Rate must be greater than 0" }),
  effective_from: z
    .string()
    .transform(val => {
      if (!val) return val;
      return new Date(val).toISOString().split("T")[0];
    })
    .refine(date => !isNaN(Date.parse(date)), {
      message: "Invalid date format",
    }),
  effective_to: z
    .string()
    .transform(val => {
      if (!val) return null;
      return new Date(val).toISOString().split("T")[0];
    })
    .refine(date => !date || !isNaN(Date.parse(date)), {
      message: "Invalid date format",
    })
    .nullish(),
  loan: z.string().uuid("Loan is required"),
});

export const baseRateCreateSchema = baseRateSchema;
export const baseRateUpdateSchema = baseRateSchema.partial();
